import React from 'react';
import styled from 'styled-components';

import { rsColor } from './responseScale';

const Run = styled.strong<{ $ink: string }>`
  color: ${({ $ink }) => $ink};
  font-weight: 700;
`;

export interface IHighlightedTextProps {
  text: string;
  /** Runs inside `text`, matched verbatim. */
  highlights?: string[] | null;
  /** Every run's colour; absent, the primary text colour. */
  ink?: string;
  /** One run's colour, over `ink`. */
  inkFor?: (run: string) => string | undefined;
  testId?: string;
}

/** Splits `text` around each highlight, matched verbatim, so no markup ever comes from the wire. */
const HighlightedText: React.FC<IHighlightedTextProps> = ({
  text,
  highlights,
  ink = rsColor.text,
  inkFor,
  testId = 'orbit-response-highlight'
}) => {
  const runs = (highlights ?? []).filter(run => run !== '');
  if (runs.length === 0) {
    return <>{text}</>;
  }
  const escaped = runs.map(run => run.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  return (
    <>
      {text.split(new RegExp(`(${escaped.join('|')})`)).map((part, index) =>
        runs.includes(part) ? (
          // Runs carry no id; their position in the sentence is their identity.
          // eslint-disable-next-line react/no-array-index-key
          <Run key={index} $ink={inkFor?.(part) ?? ink} data-testid={testId}>
            {part}
          </Run>
        ) : (
          part
        )
      )}
    </>
  );
};

export default HighlightedText;
